import { combineReducers } from 'redux';
import mainReducer from '@/bit/reducers/reducers.main-reducer';
import headerReducer from '@/bit/reducers/reducers.header-reducer';
import modalsReducer from '@/bit/reducers/reducers.modals-reducer';
import formBafReducer from '@/reducers/form-baf-reducer';
import formTvReducer from '@/reducers/form-tv-reducer';
import formAdditionalFiberReducer from '@/reducers/form-additional-fiber-reducer';
import formMobileLineReducer from '@/reducers/form-mobile-line-reducer';
import formMiMovistarNoClientReducer from '@/reducers/form-mi-movistar-no-client-reducer';
import smsReducer from '@/reducers/sms-reducer';
import addressReducer from '@/reducers/address-reducer';
import errorReducer from '@/reducers/error-reducer';
import appointmentReducer from '@/reducers/appointment-reducer';
import samReducer from '@/reducers/sam-reducer';

const rootReducers = () =>
  combineReducers({
    main: mainReducer,
    header: headerReducer,
    formBaf: formBafReducer,
    formTv: formTvReducer,
    formAdditionalFiber: formAdditionalFiberReducer,
    formMobileLine: formMobileLineReducer,
    formMiMovistarNoClient: formMiMovistarNoClientReducer,
    sms: smsReducer,
    address: addressReducer,
    error: errorReducer,
    appointment: appointmentReducer,
    sam: samReducer,
    modals: modalsReducer,
  });

export default rootReducers;
